import { isEditorShortcutBlocked } from '@waka/compat/shortcut-event';

// Retain the company import name; keyboard and clipboard paths share the control policy.
export const isEventTargetInputElement = isEditorShortcutBlocked;
